import React, {Component} from 'react'
import {Image} from 'react-konva'
import {KonvaEventObject} from 'konva/lib/Node'
import imageService from '../../../services/image.service'
import {
    BarcodeElement as BarcodeElementData
} from '../../../views/LabelBuilder/LabelBuilder.slice'

interface Props {
    element: BarcodeElementData
    onClick: (event: KonvaEventObject<MouseEvent>) => void
    onTransform: (event: KonvaEventObject<MouseEvent>) => void
    onDrag: (event: KonvaEventObject<DragEvent>) => void
    onRightClick: (event: KonvaEventObject<PointerEvent>) => void
    draggable?: boolean
}

export default class BarcodeElement extends Component<Props> {
    render() {
        const {element, draggable = true} = this.props
        const image = imageService.generateImage(element.url)
        return (
            <Image
                opacity={element.opacity}
                id={element.id}
                key={element.id}
                draggable={draggable}
                image={image}
                width={element.width}
                strokeScaleEnabled={false}
                height={element.height}
                x={element.x}
                y={element.y}
                scaleX={element.scaleX}
                scaleY={element.scaleY}
                rotation={element.rotation}
                onClick={this.props.onClick}
                onTransform={this.props.onTransform}
                onDragEnd={this.props.onDrag}
                onContextMenu={this.props.onRightClick}/>
        )
    }
}
